import type { PropsWithChildren } from 'react'

import { PdfViewerIframeEmbedProvider } from '@procurify/ui'

import { useFeatureFlag } from '@webapp/hooks/useFeatureFlag'

export const PdfIframeEmbedFeatureProvider = ({
  children,
}: PropsWithChildren<unknown>) => {
  const isIframeEmbedEnabled = useFeatureFlag('AP_10719_PDF_IFRAME_EMBED')

  return (
    <PdfViewerIframeEmbedProvider isEnabled={isIframeEmbedEnabled}>
      {children}
    </PdfViewerIframeEmbedProvider>
  )
}
